export const SettingsPageTeleportTarget = 'settings-page-teleport-target'
